import { AdDetailType, ClientAdDetailType } from "../types/ads-types";

const socials = ["facebook", "instagram", "tiktok", "website"];

const defaultAdDetails: AdDetailType = {
  preview: {
    id: 0,
    profile_picture: "",
    full_name: "Unknown",
    sub_category: "",
    rating: {
      average_rating: 0,
      review_count: 0,
    },
    premium: false,
    remote: false,
    lowest_service_price: 0,
    location: "",
  },
  contact_info: {
    id: 0,
    email: "",
    location: "",
    remote: false,
    phone: "",
    instagram: "",
    facebook: "",
    tiktok: "",
    website: "",
  },
  services: [],
  text: "No description available.",
  education: [],
  photos: [],
  reviews: [],
  user: 0,
};

const defaultClientAdDetails: ClientAdDetailType = {
  ad_data: {
    id: 0,
    title: "",
    text: "",
    sub_category: 0,
    subcategory: {
      id: 0,
      name: "Unknown",
    },
    category: {
      id: 0,
      name: "Unknown",
    },
    max_price: 0,
    min_price: 0,
    time: 0,
    phone: "",
  },
  user_data: {
    id: 0,
    email: "",
    first_name: "Unknown",
    last_name: "Unknown",
    profile_picture: null,
    remote: false,
    location_dict: {
      id: 0,
      name: "",
    },
  },
};

export { socials, defaultAdDetails, defaultClientAdDetails };
